import { render, staticRenderFns } from "./Programs.vue?vue&type=template&id=548480aa&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"
import style0 from "./Programs.vue?vue&type=style&index=0&id=548480aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548480aa",
  null
  
)

export default component.exports